import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const backendOptions = {
  loadPath: "/locales/{{lng}}/{{ns}}.json",
  crossDomain: true,
};
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "tr",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: backendOptions,
  });

export default i18n;
